import http from '../http'
import { Res } from '../type'
import { AllMyTeachingParams, AllMyTeaching, TeachingDetailParams, TeachingDetail, LiveNumData, LiveStudentParams, LiveStudent, LiveInviteInfo, UserBatchAdd } from '../Models/AllMyTeaching'
import { MyLatestTeaching } from '../Models/MyLatestTeaching'
import { CornerMarkNumberByBiz } from '../Models/CornerMarkNumberByBiz'
import { FaceStudentsOverviewParams, FaceStudentsPageParams, ReviewStudentPage, ReviewStudentPageParams, TeachExamReviewData } from '../Models/ReviewStudentPage'
import { ReviewBizPageParams, ReviewBizPage } from '../Models/ReviewBizPage'
import { ReviewHomeworkBasicInfoParams, ReviewHomeworkBasicInfo } from '../Models/ReviewHomeworkBasicInfo'
import { ReviewGetBizTypeNumberByUserParams, ReviewGetBizTypeNumberByUser } from '../Models/ReviewGetBizTypeNumberByUser'
import { HomeWorkDetailParams, HomeWorkDetail } from '../Models/HomeWorkDetail'
import { ReviewGetBizIdByNextParams, ReviewGetBizIdByNext } from '../Models/ReviewGetBizIdByNext'
import { MyTeachingSummary } from '../Models/MyTeachingSummary'
import type { OfflineTrainDetail, OfflineTrainDetailParams } from '../Models/OfflineTrainDetail'
import type { StudentPageParams, StudentPage } from '../Models/StudentPage'

/*
业务功能区角标数量
*/

export const getCornerMarkNumber = (): Res<CornerMarkNumberByBiz> => {
  return http.request({
    url: '/sands-lms/api/v1/personalCenter/cornerMarkNumberByBiz',
    method: 'GET',
    loadingShow: '0',
    toastShow: '0'
  })
}

/*
【我的授课】未来30天内授课
 */
export const getNextThirtyDays = (): Res<MyLatestTeaching> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/nextThirtyDays',
    method: 'POST',
    loadingShow: '0'
  })
}

/*
【我的授课】全部授课
*/
export const getAllMyTeaching = (data: AllMyTeachingParams): Res<AllMyTeaching> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/all',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 【教学管理】概览数据
export const getTeachingSummary = (): Res<MyTeachingSummary> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/summary',
    method: 'GET',
    loadingShow: '0'
  })
}

// 日期分组概要
export const getGroupSummary = (data: AllMyTeachingParams): Res<AllMyTeaching> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/date-group-summary',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 【我的授课】面授详情
export const getFaceTeachingDetail = (data: OfflineTrainDetailParams): Res<OfflineTrainDetail> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/face2face/detail',
    method: 'POST',
    data
    // loadingShow: '0'
  })
}

// 【我的授课】面授-学员
export const getStudentPage = (data: StudentPageParams): Res<StudentPage> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/face2face/student-page',
    method: 'POST',
    data
    // loadingShow: '0'
  })
}

// 【我的授课】面授-签到
export const getSignInManage = (data: StudentPageParams): Res<StudentPage> => {
  return http.request({
    url: '/sands-lms/api/v1/common/sign-in/manage',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 【教学管理-学员】提醒学员参加（面授/直播）
export const getUrgeStudent = (data: StudentPageParams): Res<null> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/student/remind',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 【教学管理-面搜】上传文件或图片(线下活动精彩瞬间)
export const getFileUpload = (data: StudentPageParams): Res<null> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/face2face/file-upload',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 获取消息设置
export const getSettingGet = (data: { id: number | string }): Res<null> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/face2face/setting-get',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 【教学管理】直播/面授学员-删除
export const getStudentDelete = (data: {
  "bizId": number,
  "bizType": number,
  "ids": Array<number>
}): Res<null> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/student/delete',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 批量标记完成
export const getMarkFinished = (data: {
  "face2faceId": number,
  "ids": Array<number>
}): Res<null> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/face2face/mark-finished',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 签到详情
export const getSignDetail = (params: { id: number }): Res<null> => {
  return http.request({
    url: '/sands-lms/api/v1/common/sign-in/get',
    method: 'GET',
    params,
    loadingShow: '0'
  })
}

// 【教学管理】授课详情
export const getTeachingDetail = (data: TeachingDetailParams): Res<TeachingDetail> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/livestream/detail',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 【教学管理】直播详情
export const getLiveDetail = (id: string): Res<LiveNumData> => {
  return http.request({
    url: `/sands-lms/api/v1/my-teaching/livestream/getRoomData?liveStreamId=${id}`,
    method: 'GET',
    loadingShow: '0'
  })
}

export const getLiveStudent = (data: LiveStudentParams): Res<LiveStudent> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/livestream/student-page',
    method: 'POST',
    data,
    loadingShow: data.current === 1 ? '1' : '0'
  })
}

export const getLiveInviteInfo = (id: string, type: number): Res<LiveInviteInfo> => {
  return http.request({
    url: `/sands-lms/api/v1/my-teaching/livestream/invite-info?id=${id}&type=${type}`,
    method: 'GET',
    loadingShow: '0'
  })
}

// 删除直播学员
export const deleteLiveStudent = (data: { bizId: string; bizType: number; userIds: string[] }): Res<null> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/student/delete',
    method: 'POST',
    data
  })
}

export const getDeptTree = (data: { name: string; isOpen: number; parentId: number }): Res<null> => {
  return http.request({
    url: `/sands-user/api/v1/dept/common-query?isOpen=${data.isOpen}&parentId=${data.parentId}`,
    method: 'GET',
    loadingShow: '0'
  })
}

// 获取部门负责人信息 接口ID：57784
export const getLeaderInfoByDept = (id: string): Res<null> => {
  return http.request({
    url: `/sands-user/api/v1/user/getLeaderInfoByDept?deptId=${id}`,
    method: 'GET',
    loadingShow: '0'
  })
}

// 通讯录 接口ID：57637
export const getCommonPage = (
  size: number,
  current: number,
  deptId?: string | number,
  keyWord?: string,
  name?: string,
  username?: string,
  code?: string
): Res<null> => {
  return http.request({
    url: `/sands-user/api/v1/user/common-page`,
    method: 'POST',
    data: {
      deptId,
      status: 1,
      size,
      current,
      // “全部”时传 keyWord，其它按字段精确传入
      keyWord,
      name,
      username,
      code
    },
    loadingShow: '1'
  })
}

// 获取部门下所有用户数量 接口ID：57785
export const getCountAllUserByDeptId = (deptId: string): Res<null> => {
  return http.request({
    url: `/sands-user/api/v1/user/countAllUserByDeptId?deptId=${deptId}`,
    method: 'GET',
    loadingShow: '0'
  })
}

// 【我的授课】直播/面授-添加学员 接口ID：57528
export const getBatchAdding = (data: UserBatchAdd): Res<null> => {
  return http.request({
    url: `/sands-lms/api/v1/my-teaching/student/batch-add`,
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 【教学管理】提醒参加
export const remindParticipants = (data: { bizId: string; bizType: number }): Res<null> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/student/remind',
    method: 'POST',
    data
  })
}

// 批阅列表-业务详情维度(分页)
export const getBizDetailPage = (data: {
  "bizId": "",
  "bizType": "",
  "reviewStatus": ""
}): Res<null> => {
  return http.request({
    url: '/sands-lms/api/v1/review/bizDetailPage',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 查询考试基础信息-考试批阅
export const getExamBasicInfo = (params: {
  "bizId": "",
  "bizType": "",
  "reviewStatus": ""
}): Res<null> => {
  return http.request({
    url: '/sands-lms/api/v1/review/exam/basicInfo',
    method: 'GET',
    params
  })
}

// 查询作业基础信息-作业批阅
export const getHomeworkBasicInfo = (params: ReviewHomeworkBasicInfoParams): Res<ReviewHomeworkBasicInfo> => {
  return http.request({
    url: '/sands-lms/api/v1/review/homework/basicInfo',
    method: 'GET',
    params
  })
}

// 查询考试基础信息-考试批阅
export const getExamViewList = (params: ReviewHomeworkBasicInfoParams): Res<ReviewHomeworkBasicInfo> => {
  return http.request({
    url: '/sands-lms/api/v1/review/exam/basicInfo',
    method: 'GET',
    params,
    loadingShow: '0'
  })
}

// 批阅列表-业务维度(分页)
export const getReviewBizPage = (data: ReviewBizPageParams): Res<ReviewBizPage> => {
  return http.request({
    url: '/sands-lms/api/v1/review/bizPage',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 根据当前用户获取数据量
export const getReviewGetNumberByUser = (data: ReviewGetBizTypeNumberByUserParams): Res<ReviewGetBizTypeNumberByUser> => {
  return http.request({
    url: '/sands-lms/api/v1/review/getNumberByUser',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 【作业】作业详情
export const getHomeWorkDetail = (data: HomeWorkDetailParams): Res<HomeWorkDetail> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/homework/get',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 根据当前用户和业务类型获取数据量
export const getBizTypeNumberByUser = (data: ReviewGetBizTypeNumberByUserParams): Res<ReviewGetBizTypeNumberByUser> => {
  return http.request({
    url: '/sands-lms/api/v1/review/getBizTypeNumberByUser',
    method: 'POST',
    data
  })
}
// 查看上一条或下一条批阅数据id
export const getReviewById = (data: ReviewGetBizIdByNextParams): Res<ReviewGetBizIdByNext> => {
  return http.request({
    url: '/sands-lms/api/v1/review/getBizIdByNext',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 批阅列表-学员维度(分页)
export const getReviewStudentPage = (data: ReviewStudentPageParams): Res<ReviewStudentPage> => {
  return http.request({
    url: '/sands-lms/api/v1/review/studentPage',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 【作业】批阅作业
export const getReviewHomeWork = (data: {
  "homeworkId"?: number,
  "userId"?: number,
  "isReturn"?: boolean,
  "reviewComments"?: string,
  "reviewResult"?: number,
  "score"?: number
}): Res<null> => {
  return http.request({
    url: '/sands-lms/api/v1/my-teaching/homework/review',
    method: 'POST',
    data,
    loadingShow: '0'
  })
}

// 考试批阅 获取考卷
export const getTeachingExamViewPaper = (data: {
  examRecordId: string
}): Res<TeachExamReviewData> => {
  return http.request({
    url: '/sands-lms/api/v1/exam/exam-paper-answer/get?examRecordId=' + data.examRecordId,
    method: 'post'
  })
}

// 查询所有面授-学员(分页)
export const getFaceStudentsPage = (params: FaceStudentsPageParams): Res<OfflineTrainDetail> => {
  return http.request({
    url: '/sands-lms/api/v1/face2face-students/page',
    method: 'POST',
    data: params,
    loadingShow: '0'
  })
}

export const getFaceStudentsOverview = (data: FaceStudentsOverviewParams): Res<OfflineTrainDetail> => {
  return http.request({
    url: '/sands-lms/api/v1/face2face/overview',
    method: 'post',
    data
  })
}
